import { render, staticRenderFns } from "./Modules.vue?vue&type=template&id=47d362bd&"
import script from "./Modules.vue?vue&type=script&lang=ts&"
export * from "./Modules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d362bd')) {
      api.createRecord('47d362bd', component.options)
    } else {
      api.reload('47d362bd', component.options)
    }
    module.hot.accept("./Modules.vue?vue&type=template&id=47d362bd&", function () {
      api.rerender('47d362bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modules.vue"
export default component.exports